
import React, { Component } from 'react';
import propTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as turf from '@turf/turf';

import MapMarker from './MapMarker/MapMarker';
import styles from './FlightMap.css'; //eslint-disable-line

import tripData3 from '../../tripData3';

// mapbox is loaded via CDN with a script tag in index.html
// the package on npm does not correctly minify in production with this version of create-reaact-app
const mapboxgl = window.mapboxgl; 

class FlightMap extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isBrowse: this.props.browse
    }
  }
  componentWillMount() {
    this.markers = [];
    this.popups = [];
    this.routes = [];
    this.layoverTimers = [];
    this.mapLoaded = false;
    this.routeLayersReady = false;
    this.animatedRoutes = [];
  }



  componentDidMount() {
    const { token, styleID, routeData, browse } = this.props;
    const geojson = routeData;
    const mapConfig = {
      container: 'map',
      style: `mapbox://styles/${this.props.styleID}`,
      center: geojson ? geojson.features[0].geometry.coordinates : [-122.42, 37.78],
      zoom: 3,
      dragPan: false,
      dragRotate: false,
      touchZoomRotate: false,
      interactive: false,
      scrollZoom: false,
    };

    mapboxgl.accessToken = "pk.eyJ1IjoiYjNucm90aCIsImEiOiJjamhpMWplZ2IwNXhxMzdtZTB3NnNtZXc4In0.EOA8qNzIRsE91IhmvjyL9Q" //eslint-disable-line
    this.map = new mapboxgl.Map(mapConfig);
    this.map.getCanvas().style.cursor = 'default'; // use default cursor

    this.map.on('load', () => {
      const routeLayers = 6 // how many route layers should we create
      for (let i = 0; i < routeLayers; i++) {
        this.createRouteLayers(i);
      }
      this.mapLoaded = true;
      console.log('map loaded');
      this.buildMap(this.props);
    });

  }

  componentWillReceiveProps(props) {
    this.buildMap(props);
    // const routeData = props.routeData || props.allRoutes[0];
    // const bounds = turf.bbox(routeData);
    // const topOffset = -(window.innerHeight / 2) / 4; 
    // this.map.fitBounds(bounds, {
    //   padding: 160,
    //   duration: 2000,
    //   zoom: 4,
    //   offset: [0, 0],
    // });
  }

  componentWillUnmount() {
    this.cleanUp();
    this.markers = [];
    this.popups = [];
    this.routes = [];
    this.layoverTimers = [];
    this.mapLoaded = false;
    this.routeLayersReady = false;
    this.animatedRoutes = [];
    this.map.remove();
  }

  buildMap(props) {
    this.cleanUp();
    if (!props) props = this.props;
    // if no routedata has been passed in, dont continue and reset the map to the startpoint
    if (!props.routeData && props.allRoutes && this.mapLoaded) {
      props.allRoutes.forEach((route, i) => {
        this.drawRoute(route, i);// setup initial routes
        this.createMarkers(route); //create initial markers
        this.animate(i); //initial animation
      });
      this.createPopups(props.allRoutes[0]); //create popups, use the first flight start/end since they should all be the same
      
      // fit bounds
      const bounds = turf.bbox(props.allRoutes[0]);
      const topOffset = (window.innerHeight/2) / 4; 
      this.map.fitBounds(bounds, {
        padding: 100,
        duration: 3000,
        offset: [0, topOffset],
      });

    } else if (props.routeData) {
      this.drawRoute(props.routeData, 0);
      this.createMarkers(props.routeData);
      setTimeout(this.animate.bind(this), 1000);
      this.createPopups(props.routeData);
      const bounds = turf.bbox(props.routeData);
      this.map.fitBounds(bounds, {
        padding: 60,
        duration: 2000,
        offset: [0, 0],
      });
    }
  }


  drawRoute(routeData, id) {
    // const { routeData } = props;
    const geojson = routeData;
    let route = this.routes[id];
    

    // build the routes
    route = {
      type: 'FeatureCollection',
      features: [],
    };

    geojson.features.forEach((feature, i) => {
      if (i < geojson.features.length - 1) {
        route.features.push({
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: [
              geojson.features[i].geometry.coordinates,
              geojson.features[i + 1].geometry.coordinates,
            ],
          },
        });
      }
    });

    // do the maths to generate the route arcs as individual segments
    for (let j = 0; j < route.features.length; j += 1) {
      let arc = [];
      const routeSegment = route.features[j];
      
      // Number of steps to use in the arc and animation, more steps means
      // a smoother arc and animation, but too many steps will result in a
      // low frame rate
      const steps = 200

      const start = turf.point(routeSegment.geometry.coordinates[0]);
      const end = turf.point(routeSegment.geometry.coordinates[routeSegment.geometry.coordinates.length - 1]);
      
      const greatCircle = turf.greatCircle(start, end, { npoints: steps });
  
      const arcCoordinates = greatCircle.geometry.coordinates.length === 2
        ? greatCircle.geometry.coordinates[0].concat(greatCircle.geometry.coordinates[1])
        : greatCircle.geometry.coordinates;

      // greatCircle.geometry.coordinates = arcCoordinates;
      // if (greatCircle.geometry.coordinates.length > 0) {
      //   arc = greatCircle.geometry.coordinates[0].concat(greatCircle.geometry.coordinates[1]);
      // };

      // console.log(arc);

      
      
      // Update the route with calculated arc coordinates
      routeSegment.geometry.coordinates = arcCoordinates;

      // store the step count on this route
      routeSegment.properties = {
        steps: steps - 2,
      };
    }

    // update the map line
    if (this.map.getSource(`route${id}`)) {
      this.map.getSource(`route${id}`).setData(route);
    }

    this.routes[id] = route;

    // update the animated map line and start the animation
    const animatedRouteFeatures = [];
    if (route.features.length) {
      route.features.forEach((feature, i) => {
        animatedRouteFeatures.push({
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: [
              // route.features[i].geometry.coordinates,
            ],
          },
        });
      });
    }

    this.animatedRoutes[id] = {
      type: 'FeatureCollection',
      features: animatedRouteFeatures,
    };
  }

  createMarkers(route) {
    // create markers and popups
    route.features.forEach((marker, i) => {
      // create route points by rendering MapMarker into an empty div and using that
      // as the destination of a new Marker instance
      // console.log(id, marker.geometry.coordinates[0], );
      const markerContainer = document.createElement('div'); //eslint-disable-line
      ReactDOM.render(
        React.createElement(MapMarker, {
          data: marker,
        }),
        markerContainer,
      );
      const m = new mapboxgl.Marker(markerContainer)
        .setLngLat(marker.geometry.coordinates)
        .addTo(this.map);

      this.markers.push(m);
      
    });
  }

  createPopups(route) {
    // create the popup tooltip
    route.features.forEach((marker, i) => {
      if (!marker.properties.description) return; // if there is no description, dont create a tooltip for this destinaion
      let toolTipText = marker.properties.description;
      if (this.state.isBrowse) {
        toolTipText = `${marker.properties.description}<span>$1150</span>`;
      }


      if (i === 0 || i === route.features.length - 1) {
        const p = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false,
          offset: 10,
          anchor: marker.properties.anchor ? marker.properties.anchor : null,
          // anchor: i == 0 ? 'top' : ( i == 1 ? 'left' : 'right' )
          // anchor: i % 2 == 0 ? 'bottom' : 'top' // alternate anchors
        }).setLngLat(marker.geometry.coordinates)
          .setHTML(toolTipText)
          .addTo(this.map);

        this.popups.push(p);
      }
    });
  };

  createRouteLayers(id) {
    // draw the routes
    const route = {
      type: 'FeatureCollection',
      features: [],
    };

    this.routes.push(route);
    this.map.addSource(`route${id}`, {
      type: 'geojson',
      data: route,
    });

    this.map.addLayer({
      id: `route${id}`,
      source: `route${id}`,
      type: 'line',
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-width': 1.5,
        'line-color': this.props.lineColor,
        'line-opacity': 0.2,
      },
    });

    const animatedRoute = {
      type: 'FeatureCollection',
      features: [],
    };
    this.animatedRoutes.push(animatedRoute);
    
    this.map.addSource(`route-animated${id}`, {
      type: 'geojson',
      data: animatedRoute,
    });
  
    this.map.addLayer({
      id: `route-animated${id}`,
      type: 'line',
      source: `route-animated${id}`,
      layout: {
        'line-cap': 'round',
        'line-join': 'round',
      },
      paint: {
        'line-color': this.props.lineColor,
        'line-width': 3,
        'line-opacity': 1,
      },
    });

    this.routeLayersReady = true;
  }

  animate(id) {
    if(!id) id = 0;
    console.log('animate route ', id);
    let count = 0;
    let activeSegment = 0;
    const self = this;
    const animatedRoute = this.animatedRoutes[id];
    const route = this.routes[id];
    const doAnimation = () => {
      if (!animatedRoute || !route.features) return;
      const animateLine = () => {
        animatedRoute.features[activeSegment].geometry.coordinates.push(route.features[activeSegment].geometry.coordinates[count]);
        // then update the map
        if (this.map.getSource(`route-animated${id}`)){
          // console.log('found it, updating source', animatedRoute.features[activeSegment].geometry.coordinates.length);
          this.map.getSource(`route-animated${id}`).setData(animatedRoute);
        }
      };
  
      clearInterval(this.layoverTimers[id]);
      if (route.features.length && count < route.features[activeSegment].properties.steps) {
        count += 2;
        this.ram = requestAnimationFrame(doAnimation);
      } else if (activeSegment < route.features.length - 1) {
        // pause at layover
        this.layoverTimers[id] = setTimeout(() => {
          count = 0;
          activeSegment += 1;
          this.ram = requestAnimationFrame(doAnimation);
        }, Math.floor(Math.random() * 300) + 900 );
      }
      animateLine();
    };
    doAnimation();
  }

  cleanUp() {
    console.log('cleanup map');
    
    //reset the main route
    this.routes.forEach((route, i) => {
      this.routes[i] = {
        type: 'FeatureCollection',
        features: [],
      };
      
      // if (this.map.getSource(`route${i}`)) {
      this.map.getSource(`route${i}`).setData(this.routes[i]);
      // this.map.getSource(`route${i}`).setData(route);
      // }
    });

    this.animatedRoutes.forEach((route, i) => {
      // reset the animated line
      this.animatedRoutes[i] = {
        type: 'FeatureCollection',
        features: [],
      };
      this.map.getSource(`route-animated${i}`).setData(this.animatedRoutes[i]);
    });
  
    this.markers.forEach((marker) => {
      marker.remove();
    });

    this.popups.forEach((popup) => {
      popup.remove();
    });


    this.markers = [];
    this.popups = []; 
    cancelAnimationFrame(this.ram);
    this.layoverTimers.forEach((timer) => {
      clearInterval(timer);
    });
  }

  render() {
    let origin = null
    let destination = null;
    let startDate = null;
    let endDate = null;

    if (this.props.allRoutes && this.props.allRoutes.length) {
      const routeData = this.props.allRoutes[0];
      origin = routeData ? routeData.features[0].properties.description : null;
      destination = routeData ? routeData.features[routeData.features.length - 1].properties.description : null;
      
      startDate = routeData.features[0].properties.date.format('ddd, M/D') || null;
      endDate = routeData.features[routeData.features.length - 1].properties.date.format('ddd, M/D') || null;

      if (startDate === endDate) endDate = null;
    }
    
    return (
      <div>
        <div className="mapWrapper">
          <div className="mapHeader">
            {origin && destination ? <div className="mapHeaderRoute">{origin} - {destination}</div> : null}
            {startDate ? <div className="mapHeaderDate">{startDate} {endDate ? '-' : ''} {endDate}</div> : null }
          </div>
          <div id="map" />
          {/* <div className="mapGradientOverlay" /> */}
        </div>
      </div>
    );
  }
}

FlightMap.propTypes = {
  routeData: propTypes.shape({
    features: propTypes.arrayOf(propTypes.object),
  }),
};

FlightMap.defaultProps = {
  styleID: "b3nroth/cjig986vl3xbt2rpe8qacv599",
  lineColor: "#ffffff",
  routeData: tripData3[0],
};

function mapStateToProps({ map, main }) {
  return {
    // routeData: map.routeData,
    // allRoutes: map.allRoutes,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadRouteData: data =>
      dispatch({
        type: 'LOAD_DATA',
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlightMap);



// WEBPACK FOOTER //
// ./src/components/FlightMap/FlightMap.jsx